// The Result / error convention (contracts.md registry row 7).
//
// Expected, recoverable failures are VALUES, not thrown exceptions, so the type
// system forces every caller to handle both branches and no internal detail leaks
// across a boundary (app-engineering error-taxonomy). Exceptions stay reserved for
// genuinely unexpected, unrecoverable conditions (fail fast).
/** Construct a success. */
export const ok = (value) => ({ ok: true, value });
/** Construct a failure. */
export const err = (error) => ({ ok: false, error });
/** Type guard: narrows a Result to its success branch. */
export const isOk = (result) => result.ok;
/** Type guard: narrows a Result to its failure branch. */
export const isErr = (result) => !result.ok;
/** Return the success value or a fallback. Never throws. */
export const unwrapOr = (result, fallback) => result.ok ? result.value : fallback;
/**
 * The closed, canonical error-code set for a boundary failure. A boundary (route
 * handler, server action) maps every internal failure onto exactly one of these
 * and a user-safe message. Ports narrow to their own code sets (see ports/*).
 */
export const ERROR_CODES = [
    "unauthorized", // not authenticated
    "forbidden", // authenticated but denied (default-deny)
    "not_found", // absent, or present-but-not-yours (existence is not revealed)
    "validation", // input failed the boundary schema
    "conflict", // state conflict / uniqueness violation
    "rate_limited", // caller exceeded a rate/quota
    "timeout", // an operation exceeded its deadline
    "unavailable", // a dependency is down; fail closed on privileged paths
    "internal", // unexpected; never carries internal detail to the client
];
/** Build an {@link AppError} with the given closed code and a safe message. */
export const appError = (code, message) => ({
    code,
    message,
});
//# sourceMappingURL=result.js.map